import styled from 'styled-components';

export const ExpandButton = styled.button`
  background: transparent;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  right: 10px;
  font-size: 18px;
  cursor: pointer;
  overscroll-behavior: contain;

  @media (hover: hover) {
    &:hover {
      svg path {
        stroke: #757575;
      }
    }
  }
`;
